import { Check, Close } from '@mui/icons-material';
import { Button, Stack, Typography } from '@mui/material';
import { EditableDataGrid } from '../../../builderPackage/components/editableDataGrid/editableDataGrid';
import { useAppSelector } from '../../../store/hooks';
var ViewPDIQuestions = function (props) {
    var _currValue$filter;
    var onChange = props.onChange, value = props.value, _a = props.name, name = _a === void 0 ? 'Questions' : _a;
    var crud = useAppSelector(function (state) { return state === null || state === void 0 ? void 0 : state.crud; });
    var currValue = value[name];
    console.log('-currValue--', currValue);
    var PassCount = currValue === null || currValue === void 0 || (_currValue$filter = currValue.filter(function (item) { return (item === null || item === void 0 ? void 0 : item.InspectionResult) === 1; })) === null || _currValue$filter === void 0 ? void 0 : _currValue$filter.length;
    console.log('-PassCount--', PassCount);
    var columns = [{
            type: 'string',
            field: 'QuestionName',
            headerName: 'Name',
            flex: 1,
            minWidth: 200,
            headerAlign: 'left'
        }, {
            type: 'string',
            field: 'InspectionCriteria',
            headerName: 'Inspection criteria',
            flex: 1,
            minWidth: 220,
            headerAlign: 'center'
        }, {
            type: 'string',
            field: 'IssueDescription',
            headerName: 'SOP',
            flex: 1,
            minWidth: 120,
            headerAlign: 'center'
        }, {
            type: 'actions',
            field: 'InspectionResult',
            headerName: 'Inspection result',
            flex: 1,
            minWidth: 150,
            headerAlign: 'center',
            valueSetter: function () { },
            renderCell: function (params) {
                var _params$row, _params$row2;
                console.log('params --- 000 --', params === null || params === void 0 || (_params$row = params.row) === null || _params$row === void 0 ? void 0 : _params$row.InspectionResult);
                return /*#__PURE__*/ React.createElement(Stack, {
                    display: "inline-flex",
                    direction: "row",
                    columnGap: 2
                }, (params === null || params === void 0 || (_params$row2 = params.row) === null || _params$row2 === void 0 ? void 0 : _params$row2.InspectionResult) === 1 ? /*#__PURE__*/ React.createElement(Button, {
                    id: "pass",
                    variant: "contained",
                    color: "success",
                    size: "icon",
                    sx: {
                        p: 0.5
                    }
                }, /*#__PURE__*/ React.createElement(Check, {
                    id: "pass"
                })) : /*#__PURE__*/ React.createElement(Button, {
                    id: "fail",
                    variant: "contained",
                    color: "error",
                    size: "icon",
                    sx: {
                        p: 0.5
                    }
                }, /*#__PURE__*/ React.createElement(Close, {
                    id: "fail"
                })));
            }
        }, {
            type: 'string',
            field: 'Value',
            headerName: 'Actual value',
            flex: 1,
            headerAlign: 'center',
            minWidth: 180,
            align: 'center'
        }, {
            type: 'string',
            field: 'Remarks',
            headerName: 'Remarks',
            flex: 1,
            headerAlign: 'center',
            minWidth: 180,
            align: 'center'
        }, {
            type: 'string',
            field: 'CustomerVoiceName',
            headerName: 'Customer voice',
            flex: 1,
            headerAlign: 'center',
            minWidth: 180,
            align: 'center'
        }, {
            type: 'string',
            field: 'ObservationName',
            headerName: 'Observation',
            flex: 1,
            headerAlign: 'center',
            minWidth: 180,
            align: 'center'
        }, {
            type: 'string',
            field: 'DefectCategoryName',
            headerName: 'Defect category',
            flex: 1,
            headerAlign: 'center',
            minWidth: 180,
            align: 'center'
        }, {
            type: 'string',
            field: 'ActionTakenName',
            headerName: 'Action taken',
            flex: 1,
            headerAlign: 'center',
            minWidth: 180,
            align: 'center'
        }, {
            type: 'string',
            field: 'SAObservation',
            headerName: 'SA suggestions',
            flex: 1,
            headerAlign: 'center',
            minWidth: 180,
            align: 'center'
        }];
    return /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement(EditableDataGrid, {
        dataGridHeader: /*#__PURE__*/ React.createElement(Stack, {
            direction: 'row',
            position: 'relative'
        }, /*#__PURE__*/ React.createElement(Typography, {
            fontWeight: 'bold'
        }, value === null || value === void 0 ? void 0 : value.QuestionGroupName)),
        isCollapsible: true,
        columns: columns,
        dataGridProps: {
            checkboxSelection: false,
            disableRowSelectionOnClick: true,
            hideFooter: true,
            sx: {
                borderRadius: 0,
                borderLeft: 'none',
                borderRight: 'none',
                borderTop: 0
            }
        },
        getToolbarActions: function () { return []; },
        disableAddRow: true,
        disableDeleteRow: true,
        rows: currValue || [],
        onChange: onChange
    }));
};
export default ViewPDIQuestions;
